import { clickEventFromElement } from 'components/google-analytics/google-analytics';
import { downloadUrl } from 'lib/constants';
import * as React from 'react';

type PageFooterStaticProps = {
    geoIpCountry?: string | null;
};

const PageFooterStatic: React.FC<PageFooterStaticProps> = (props: PageFooterStaticProps) => {
    const { geoIpCountry } = props;

    return (
        <div id="footer" className="wrapper black-bg white">
            <div className="content">
                <div className="flex space-between v-center md:h-center">
                    <div>
                        <img
                            className="logo"
                            src="/bumble-honey-ambassadors/icons/bumble_yellow.svg"
                            alt="Bumble Logo"
                        />
                        <a
                            className="download white weight-medium-italic"
                            href={downloadUrl}
                            target="_blank"
                            rel="noreferrer"
                            data-category="bumble-honey-ambassadors Navigation"
                            data-action="Button Click Footer"
                            data-label="Download app"
                            onClick={(event) => clickEventFromElement(event)}
                        >
                            Download Now
                        </a>
                    </div>
                    <a
                        href="http://apple.co/ASA2021-Winners"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="2021: Trend of the year"
                    >
                        <img
                            className="trend-award md:hide"
                            src="/bumble-honey-ambassadors/icons/2021_trend_of_the_year_white.svg"
                            alt="2021: Trend of the year"
                        />
                    </a>
                </div>
                <div className="links flex">
                    <div className="section w-1-2 md:w-1-1">
                        <div className="flex wrap space-between">
                            <div style={{ paddingRight: 24 }}>
                                <p className="yellow weight-bold" style={{ paddingBottom: 12 }}>
                                    The App
                                </p>
                                <a
                                    className="white weight-book"
                                    href="https://bumble.com/en/date"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Bumble Date
                                </a>
                                <a
                                    className="white weight-book"
                                    href="https://bumble.com/en/bff"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Bumble BFF
                                </a>

                                <a
                                    className="white weight-book"
                                    href="https://bumble.com/en/bizz"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Bumble Bizz
                                </a>
                            </div>
                            <div className="md:no-padding" style={{ paddingRight: 12 }}>
                                <p className="yellow weight-bold" style={{ paddingBottom: 12 }}>
                                    The Company
                                </p>
                                <a
                                    className="white weight-book"
                                    href="https://bumble.com/en/help"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Help Centre
                                </a>
                                <a
                                    className="white weight-book"
                                    href="https://bumble.events/bumbleirlthemenew"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Events
                                </a>

                                <a
                                    className="white weight-book"
                                    href="https://bumble.com/en/guidelines"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Guidelines
                                </a>
                                <a
                                    className="white weight-book"
                                    href="https://bumble.com/en/privacy"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Privacy Policy
                                </a>
                                <a
                                    className="white weight-book"
                                    href="https://bumble.com/en/terms"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Terms &amp; Conditions
                                </a>
                                {geoIpCountry !== 'us' ? (
                                    <a
                                        className="white weight-book"
                                        href="https://bumble.com/cookie-policy"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        Cookie Policy
                                    </a>
                                ) : (
                                    <a
                                        className="white weight-book js-ccpa-privacy"
                                        href="/"
                                        rel="noreferrer"
                                    >
                                        Do not sell or share my personal information
                                    </a>
                                )}
                                <a
                                    className="white weight-book"
                                    href="https://bumble.com/en/contact-us"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Contact Us
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="section w-1-2 md:w-1-1">
                        <div className="flex wrap space-between">
                            <div className="md:no-padding" style={{ paddingRight: 12 }}>
                                <p className="yellow weight-bold">The Buzz</p>
                                <a
                                    className="white weight-book"
                                    href="https://bumble.com/en/the-buzz/love"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Love
                                </a>
                                <a
                                    className="white weight-book"
                                    href="https://bumble.com/en/the-buzz/friendship"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Friendship
                                </a>
                                <a
                                    className="white weight-book"
                                    href="https://bumble.com/en/the-buzz/career"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Career
                                </a>
                                <a
                                    className="white weight-book"
                                    href="https://bumble.com/en/the-buzz/wellness"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Wellness
                                </a>
                                <a
                                    className="white weight-book"
                                    href="https://bumble.com/en/the-buzz/how-to"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    How-to
                                </a>
                                <a
                                    className="white weight-book"
                                    href="https://bumble.com/en/the-buzz/events"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Events
                                </a>
                                <a
                                    className="white weight-book"
                                    href="https://bumble.com/success-stories"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Submit a story
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex space-between md:column">
                    <div className="md:h-center block md:center-align">
                        <img
                            className="trend-award lg:hide block"
                            src="/bumble-honey-ambassadors/icons/2021_trend_of_the_year_white.svg"
                            alt="2021: Trend of the year"
                        />
                        <img
                            className="make-the-first-move"
                            src="/bumble-honey-ambassadors/icons/make_the_first_move_white.svg"
                            alt="Make the first move"
                        />
                        <p className="copyright">©2022 Bumble. All Rights Reserved</p>
                    </div>
                    <div className="flex social-icons md:h-center">
                        <a href="https://instagram.com/bumble" target="_blank" rel="noreferrer">
                            <img
                                src="/bumble-honey-ambassadors/icons/instagram.svg?v=1"
                                alt="Instagram"
                            />
                            <img
                                src="/bumble-honey-ambassadors/icons/instagram_hover.svg?v=1"
                                alt="Instagram"
                            />
                        </a>
                        <a
                            href="https://www.facebook.com/bumbleapp"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img
                                src="/bumble-honey-ambassadors/icons/facebook.svg?v=1"
                                alt="Facebook"
                            />
                            <img
                                src="/bumble-honey-ambassadors/icons/facebook_hover.svg?v=1"
                                alt="Facebook"
                            />
                        </a>
                        <a href="https://twitter.com/bumble" target="_blank" rel="noreferrer">
                            <img
                                src="/bumble-honey-ambassadors/icons/twitter.svg?v=1"
                                alt="Twitter"
                            />
                            <img
                                src="/bumble-honey-ambassadors/icons/twitter_hover.svg?v=1"
                                alt="Twitter"
                            />
                        </a>
                        <a
                            href="https://www.linkedin.com/company/bumbleinc/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img
                                src="/bumble-honey-ambassadors/icons/linkedin.svg?v=1"
                                alt="LinkedIn"
                            />
                            <img
                                src="/bumble-honey-ambassadors/icons/linkedin_hover.svg?v=1"
                                alt="LinkedIn"
                            />
                        </a>
                        <a
                            href="https://www.pinterest.com/bumbleapp/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img
                                src="/bumble-honey-ambassadors/icons/pinterest.svg?v=1"
                                alt="Pinterest"
                            />
                            <img
                                src="/bumble-honey-ambassadors/icons/pinterest_hover.svg?v=1"
                                alt="Pinterest"
                            />
                        </a>
                        <a href="https://www.youtube.com/c/bumble" target="_blank" rel="noreferrer">
                            <img
                                src="/bumble-honey-ambassadors/icons/youtube.svg?v=1"
                                alt="Youtube"
                            />
                            <img
                                src="/bumble-honey-ambassadors/icons/youtube_hover.svg?v=1"
                                alt="Youtube"
                            />
                        </a>
                        <a href="https://www.tiktok.com/@bumble" target="_blank" rel="noreferrer">
                            <img
                                src="/bumble-honey-ambassadors/icons/tiktok.svg?v=1"
                                alt="TikTok"
                            />
                            <img
                                src="/bumble-honey-ambassadors/icons/tiktok_hover.svg?v=1"
                                alt="TikTok"
                            />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PageFooterStatic;
